import React, { FC, useEffect, useRef, useState } from "react";
import WechatPng from "@/assets/images/login/wechat.png";
import { ReactComponent as RefreshSvg } from "@/assets/icons/refresh.svg";
import Icon from "@/components/Icon";
import { withRouter } from "react-router-dom";

import { Toast } from "@/components/Toast";
import { getWeChatQrCode } from "@/modules/login/api";
import LoginStore, { loginStore } from "@/modules/login/store";
import { CircularProgress, Flex, Image, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { langStore, translate } from "@noli/business";
import { Toast_Words } from "@/utils/lang";
import { getQrCodeImage } from "@/api/url";
import { captureException } from "@sentry/react";

interface QRCodeVerificationProps {
  onSuccess?: () => void;
  loginStore?: LoginStore;
}

const QRCodeVerification: FC<any> = (props: any) => {
  const [qrCode, setQrCode] = useState("");
  const lang = langStore.tgt;
  const [loading, setLoading] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const { visible } = loginStore!.loginState;
  const timer = useRef<any>(null);
  const loopRequest = useRef<any>(null);

  const getQrCode = () => {
    setLoading(true);
    getWeChatQrCode()
      .then((res: any) => {
        if (res.errCode != 0) {
          Toast({
            status: "error",
            title: res.msg,
          });
        } else {
          const { url, expiresIn, key } = res.data;
          const expireTime = expiresIn * 1000;
          loginStore?.setWeChatKey(key);
          const u = new URL(url);
          getQrCodeImage(u.pathname + u.search).then((res) => {
            if (res) {
              setQrCode(URL.createObjectURL(res));
            }
          });
          if (timer.current) clearTimeout(timer.current);
          timer.current = setTimeout(() => {
            setIsExpired(true);
          }, expireTime);

          getLoginResult(expireTime);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getLoginResult = async (expireTime: number) => {
    loopRequest.current = await loginStore?.getWeChatQrCodeResult(expireTime);
    loopRequest.current.start().then((res: any) => {
      if (res.data.bindPhone) {
        loginByWeChat();
      } else {
        loginStore?.setDialogType("phoneBind");
      }
    });
  };

  const loginByWeChat = () => {
    loginStore
      ?.loginByWeChatQrCode()
      .then(async (res: any) => {
        const { is_new } = res;
        if (res.errCode == 0) {
          Toast({
            title: translate(Toast_Words.loginSuccess, lang),
            status: "success",
          });
          loginStore?.closeLoginDialog();
        } else {
          Toast({
            title: translate(Toast_Words.loginFailed, lang),
            status: "error",
          });
        }
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // 获取登录二维码
    if (visible && loginStore.dialogType === "weChat") handleRefresh();
    else loopRequest.current?.stop();
    return () => {
      loopRequest.current?.stop();
    };
  }, [visible, loginStore.dialogType]);

  function handleRefresh() {
    setIsExpired(false);
    setLoading(true);
    setQrCode("");
    getQrCode();
  }

  return (
    <Flex justifyContent="center" align="center" flexDir="column">
      <Flex justifyContent="center" style={{ marginBottom: "16px" }}>
        <Image w="36px" src={WechatPng} marginRight="8px" />
        <Text color="#86909C" lineHeight="28px">
          微信扫码，关注公众号
        </Text>
      </Flex>
      <Flex marginBottom="16px" justifyContent="center">
        <Flex
          w="215px"
          h="215px"
          flexShrink="0"
          flexGrow="0"
          borderRadius="8px"
          border="1px solid #E5E6EB"
          justifyContent="center"
          alignItems="center"
          position="relative"
        >
          {qrCode ? (
            <Image src={qrCode} borderRadius="8px" draggable="false" />
          ) : (
            <CircularProgress isIndeterminate color="green.300" />
          )}
          {isExpired && (
            <Stack
              onClick={handleRefresh}
              borderRadius="8px"
              position="absolute"
              w="100%"
              h="100%"
              bg="blackAlpha.500"
              justifyContent="center"
              alignItems="center"
            >
              <Icon style={{ width: "26px", height: "26px" }} svg={RefreshSvg} />
              <Text color="#fff">刷新二维码</Text>
            </Stack>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default withRouter(observer(QRCodeVerification));
